export default function AlertsLog({ alerts, onClear, soundOn, onToggleSound }) {
  return (
    <div className="bg-slate-900/70 border border-slate-800 rounded-xl flex flex-col h-full">
      <div className="flex justify-between items-center px-3 py-2 border-b border-slate-800">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 font-bold">
          <i className="fa-solid fa-bell text-amber-400 mr-1.5"/> ICT Event Tape
        </div>
        <div className="flex gap-1">
          <button data-testid="toggle-sound" onClick={onToggleSound}
            className={`text-[10px] font-bold px-2 py-0.5 rounded border transition-all ${soundOn ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-400" : "bg-slate-800 border-slate-700 text-slate-500"}`}>
            <i className={`fa-solid ${soundOn ? "fa-volume-high" : "fa-volume-xmark"} mr-1`}/>
            {soundOn ? "ON" : "OFF"}
          </button>
          <button data-testid="clear-alerts" onClick={onClear}
            className="text-[10px] font-bold px-2 py-0.5 rounded bg-slate-800 border border-slate-700 text-slate-400 hover:text-white">Clear</button>
        </div>
      </div>
      <div data-testid="alerts-list" className="flex-1 overflow-y-auto p-2 space-y-1.5 text-[11px] font-mono">
        {alerts.length === 0 && <div className="text-slate-600 text-center py-4">Awaiting algorithmic delivery...</div>}
        {alerts.slice().reverse().map((a, idx) => (
          <div key={a.id || idx} className={`flex items-start gap-2 px-2 py-1.5 rounded border ${TYPE_STYLE[a.kind] || "border-slate-800 bg-slate-900/50"}`}>
            <span className="text-[9px] text-slate-500 mt-0.5">#{a.barIndex}</span>
            <div className="flex-1">
              <div className="font-bold">{a.label}</div>
              {a.detail && <div className="text-slate-400 text-[10px]">{a.detail}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const TYPE_STYLE = {
  FVG:        "border-amber-500/30 bg-amber-500/5 text-amber-300",
  IFVG:       "border-orange-500/30 bg-orange-500/5 text-orange-300",
  BOS:        "border-yellow-500/30 bg-yellow-500/5 text-yellow-300",
  MSS:        "border-fuchsia-500/30 bg-fuchsia-500/5 text-fuchsia-300",
  SWEEP_BSL:  "border-sky-500/30 bg-sky-500/5 text-sky-300",
  SWEEP_SSL:  "border-sky-500/30 bg-sky-500/5 text-sky-300",
  SMT:        "border-pink-500/30 bg-pink-500/5 text-pink-300",
  SESSION:    "border-blue-500/30 bg-blue-500/5 text-blue-300",
  PREMIUM:    "border-rose-500/30 bg-rose-500/5 text-rose-300",
  DISCOUNT:   "border-emerald-500/30 bg-emerald-500/5 text-emerald-300",
  ORDER_FILL: "border-slate-500/30 bg-slate-500/5 text-slate-200",
  PROFIT:     "border-emerald-500/30 bg-emerald-500/5 text-emerald-300",
  LOSS:       "border-rose-500/30 bg-rose-500/5 text-rose-300",
};
